import { useEffect, useState } from "react";

import { Application } from "@core/Application";

const DEFAULT_TIMEZONE = "America/Argentina/Buenos_Aires";

export const useTimezone = () => {
    const [timezone, setTimezone] = useState(() => Application.shared().timezone || DEFAULT_TIMEZONE);

    useEffect(() => {
        const handleTimezoneChange = () => {
            setTimezone(Application.shared().timezone || DEFAULT_TIMEZONE);
        };

        window.addEventListener("qontact:timezone", handleTimezoneChange);
        return () => window.removeEventListener("qontact:timezone", handleTimezoneChange);
    }, []);

    return { timezone };
};
